import type {KeyboardEvent} from 'react';

export function isKeyDownAction(event: KeyboardEvent<HTMLElement>) {
  return event.key === ' ' || event.key === 'Enter';
}

// Instead of using onPress, we have to use a combination of onClick and onKeyDown
// to prevent pointer events from onPress from propagating
// Refer to https://github.com/adobe/react-spectrum/issues/1513
export const getButtonPressProps = (
  onPress: () => void | undefined,
  disabled?: boolean,
): {
  onPress: () => void;
  onClick: () => void;
  onKeyDown: (e: KeyboardEvent<HTMLElement>) => void;
} => {
  if (disabled || !onPress) {
    return {
      onPress: () => {},
      onClick: () => {},
      onKeyDown: () => {},
    };
  }

  return {
    onPress: () => {}, // onPress is a necessary prop for Button
    onClick: onPress,
    onKeyDown: (e: KeyboardEvent<HTMLElement>) => {
      if (isKeyDownAction(e)) {
        onPress();
      }
    },
  };
};
